import { render, staticRenderFns } from "./DS_twoTout.vue?vue&type=template&id=91f35628&"
import script from "./DS_twoTout.vue?vue&type=script&lang=js&"
export * from "./DS_twoTout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports